export default "__VITE_ASSET__COsst2pl__"